import type { FaireProductEntity } from "../../entity_types/product";

export const p_ajyr64fg3b: FaireProductEntity = {
  token: "p_ajyr64fg3b",
  type: "product",
  name: "Freeze Dried Banana Slices",
  brandToken: "b_d7mymnraud",
  brandName: "Big Green Organic Food",
  imageUrl:
    "https://cdn.faire.com/fastly/db658b49287a48b62d9e5978f951db9869c7fd8627c7f1a36592dc65a90519ec.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6d9024cc3dd7da622ed9522166f942ec8ebeb86f35af678eca2c12736385b5c8.jpeg",
    "https://cdn.faire.com/fastly/f32274db3cef76f3c88a416fa2de5428f8cc765044f869e478ddb7292b0e286d.png",
    "https://cdn.faire.com/fastly/24b03c1ad2fc92defcef0cba3a018b0c98366115cd915041a8684416624b4b78.png",
  ],
  priceDollars: 1.94,
  description:
    "Freeze Dried Banana Slices\n\nDisclaimer: WARNING: This product can expose you to chemicals including arsenic, which is known to the State of California to cause cancer. For more information go to www.P65Warnings.ca.gov.",
  tags: [],
  msrpDollars: 2.76,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:36.854Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
